class Dropdown extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.triggerElement = this.shadowRoot.querySelector('slot')?.assignedElements()?.[0];
    this.popupElement = this.shadowRoot.querySelector('slot')?.assignedElements()?.[1];

    this.triggerElement?.addEventListener("click", () => {
      this.toggleDropdown();
    })

    this.items = this.querySelectorAll("x-dropdown-item");

    this.items?.forEach(el => {
      el.addEventListener("click", () => {
        const title = el.getAttribute("title");
        const value = el.getAttribute("value");
        const name = el.getAttribute("name");
        this.dispatchEvent(new CustomEvent("change", {
          bubbles: true,
          cancelable: true,
          detail: {
            title,
            value,
            name,
          }
        }))
        this.triggerElement.innerHTML = title;
        this.toggleDropdown();
      })
    })

    this.toggleDropdown = () => {
      this.popupElement.classList.toggle("open");
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  css() {
    return `
      :host {
        width: max-content;
        height: max-content;
      }
      
      div {
        width: 100%;
        height: 100%;
        position: relative;
      }
    `;
  }

  template() {
    return `
      <div>
        <slot></slot>
      </div>
    `;
  }
}

class DropdownTrigger extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.buttonElement = this.shadowRoot.querySelector("button");
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  static get observedAttributes() {
    return ['width',  'class']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name] = newValue;
  }

  set width(val) {
    this.buttonElement.setAttribute("style", `width: ${val};`);
  }

  set class(val) {
    this.buttonElement.setAttribute("class", val);
  }

  css() {
    return `
      :host {
        width: max-content;
        height: max-content;
      }
      
      button {
        width: 100%;
        height: 100%;
        background: #fff;
        padding: 10px 16px 10px 16px;
        gap: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 24px;
        border: 1px solid #CACACA;
        cursor: pointer;
      }

      .rounded-lg {
        border-radius: 8px;
      } 
      
      .border {
        border: 1px solid transparent;
      } 
      
      .border-grey-200 {
        border-color: #ECECEC;
      }

      .h-form-input {
        height: 54px;
      }

      .text-input {
        font-family: "GT America", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 22.64px;
        text-align: left;
        color: #03131E;
        padding: 12px 24px 12px 24px;
      }

      .w-full {
        width: 100%;
      }
    `;
  }

  template() {
    return `
      <button>
        <slot></slot>
      </button>
    `;
  }
}

class DropdownOptions extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.popupElement = this.shadowRoot.querySelector("div");
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  static get observedAttributes() {
    return ['class'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name] = oldValue || newValue;
  }

  set class(val) {
    this.popupElement.classList.toggle(val);
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
      }
      
      :host > div {
        box-shadow: 4px 13px 40px 0px #00000026;
        background: #FFFFFF;
        border-radius: 12px;
        min-width: 229px;
        position: absolute;
        top: calc(100% + 10px);
        right: 0px;
        z-index: -99;
        opacity: 0;
        pointer-events: none;
        width: 100%;
      }

      :host > div > div {
        overflow: hidden;
      }

      .open {
        z-index: 99 !important;
        opacity: 1 !important;
        pointer-events: all !important;
      }
    `;
  }

  template() {
    return `
      <div>
        <div>
          <slot></slot>
        </div>
      </div>
    `;
  }
}

class DropdownItem extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
      }
      
      div {
        padding: 16px;
        font-family: "GT America", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 17.61px;
        text-align: left;
        color: #03131E;
      }

      div:hover {
        cursor: pointer;
        background: #f2f5f7;
      }
    `;
  }

  template() {
    return `
      <div>
        <slot></slot>
      </div>
    `;
  }
}

customElements.define("x-dropdown", Dropdown);
customElements.define("x-dropdown-trigger", DropdownTrigger);
customElements.define("x-dropdown-options", DropdownOptions);
customElements.define("x-dropdown-item", DropdownItem);